"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = exports.extractShortSha = exports.checkDeepEquality = exports.addUnique = exports.numberWithCommas = exports.isSubset = exports.truncateText = exports.checkIfIsInternalEmail = exports.validateEmailRegex = exports.lightenDarkenColor = exports.duplicateEntityName = exports.areSetsEqual = exports.subtract = exports.groupBy = exports.toggleAll = exports.toggleInSet = exports.getDistinctArrayItemByPropertyName = exports.onlyUnique = exports.getDateString = exports.calculateGridClassNames = exports.numberFormatter = exports.trimText = exports.getDeepCopy = exports.mergeClasses = void 0;
var guards_1 = require("./guards");
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
/**
 * Merge css classes produced by Mui useStyles hook
 * @param classes
 * @returns string
 */
var mergeClasses = function (classes) {
    var result = classes.filter(function (item) { return item !== undefined && item !== null && item !== ''; });
    if (result.length <= 0)
        return '';
    return result.join(' ');
};
exports.mergeClasses = mergeClasses;
/**
 * Takes any object type and returns a deep copy of it
 * @param obj
 */
var getDeepCopy = function (obj) { return JSON.parse(JSON.stringify(obj)); };
exports.getDeepCopy = getDeepCopy;
var trimText = function (input, maxChars) {
    if ((0, guards_1.isUndefinedOrNullOrEmptyString)(input))
        return input;
    if (input.length > maxChars)
        return input.substring(0, maxChars) + '...';
    return input;
};
exports.trimText = trimText;
/**
 * Takes any number and returns its abbreviated version
 * @example numberFormatter(1000) => 1k
 * @
 * @param value
 * @returns The abbreviated value
 */
var numberFormatter = function (value) {
    var abbreviations = ['k', 'M', 'B', 'T'];
    var index = -1;
    var divider = 1000;
    var quotient = 1;
    while (quotient >= 1) {
        if (value / divider < 1)
            break;
        quotient = value / divider;
        index++;
        divider *= 1000;
    }
    if (index === -1 || index > 3)
        return value.toString();
    else
        return "".concat(Math.round(quotient * 100) / 100).concat(abbreviations[index]);
};
exports.numberFormatter = numberFormatter;
/**
 * Takes the parameters below and returns a string array representing css class names
 * based on isAudienceHovered , someAudienceHovered and if the index is even or odd
 * @example see Grid.component.tsx on Platform2-charting
 * @param classes
 * @param index
 * @param length
 * @param isAudienceHovered
 * @param someAudienceHovered
 * @returns a string array representing css classes
 */
var calculateGridClassNames = function (classes, index, length, isAudienceHovered, someAudienceHovered) {
    var classeNames = [];
    classeNames.push(classes.element);
    if (index === length - 1) {
        if (isAudienceHovered) {
            classeNames.push(classes.lastHovered);
        }
        else {
            someAudienceHovered ? classeNames.push(classes.lastHidden) : classeNames.push(classes.last);
        }
    }
    !(index & 1) ? classeNames.push(classes.even) : classeNames.push(classes.odd);
    return classeNames;
};
exports.calculateGridClassNames = calculateGridClassNames;
/**
 * Takes a Date object and returns a date string
 * @example getDateString(new Date()) => 6 Feb 2020 12:13
 * @param date
 * @returns a date string
 */
var getDateString = function (date) {
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    return "".concat(date.toLocaleDateString('en-GB', options), " ").concat(date.getHours(), ":").concat(date.getMinutes());
};
exports.getDateString = getDateString;
/**
 * A function mainly used as a predicate on .filter js method
 * @example [1, 1, 1, 1].filter(onlyUnique) => [1]
 * @param value
 * @param index
 * @param self
 * @returns unique values of array
 */
var onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index;
};
exports.onlyUnique = onlyUnique;
/**
 * Takes an array and a property name and removes duplicates present in array based on property
 * @param inputArray
 * @param propertyName
 * @returns an array devoid of duplicate entries
 */
var getDistinctArrayItemByPropertyName = function (inputArray, propertyName) {
    var map = new Map(inputArray.map(function (x) { return [x[propertyName], x]; }));
    return __spreadArray([], __read(map.values()), false);
};
exports.getDistinctArrayItemByPropertyName = getDistinctArrayItemByPropertyName;
/**
 * Removes or adds an item in the provided set
 * based on the item existing or not
 * @param item
 * @param collection
 * @returns the given set with or without the given item
 */
var toggleInSet = function (item, collection) {
    if (collection === undefined) {
        return new Set([item]);
    }
    if (collection.has(item)) {
        collection.delete(item);
        return new Set(collection);
    }
    else {
        collection.add(item);
        return new Set(collection);
    }
};
exports.toggleInSet = toggleInSet;
/**
 * Accepts two Sets and returns either their distinct sum or an empty Set
 * @example
 * toggleAll(new Set([1, 2], new Set([1, 2]))) => Set(O)
 * toggleAll(new Set([1, 2], new Set([2, 3]))) => Set([1, 2, 3])
 * @param allIds
 * @param selectedIds
 * @returns an empty Set if they have the same values or a set with distinct values from both
 */
var toggleAll = function (allIds, selectedIds) {
    if (selectedIds === undefined) {
        return allIds;
    }
    if ((0, exports.subtract)(__spreadArray([], __read(allIds), false), __spreadArray([], __read(selectedIds), false)).length === 0) {
        return new Set((0, exports.subtract)(__spreadArray([], __read(selectedIds), false), __spreadArray([], __read(allIds), false)));
    }
    else {
        return new Set(__spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(selectedIds), false), __read(new Set(allIds)), false))), false));
    }
};
exports.toggleAll = toggleAll;
/**
 * Accepts an array of objects and returns a Map()
 * with items grouped under the outcome of the keyGetter function
 * @param array
 * @param keyGetter
 * @returns a Map() with key: the outcome of the keyGetter forEach item of the array
 * and value: the items of the array that have the same key
 */
var groupBy = function (array, keyGetter) {
    var map = new Map();
    array.forEach(function (item) {
        var key = keyGetter(item);
        var collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
};
exports.groupBy = groupBy;
/**
 * Removes from arrayA the values of arrayB
 * @example subtract([1, 2, 3, 4], [3, 4, 5, 6]) => [1, 2]
 * @param arrayA
 * @param arrayB
 * @returns arrayA without the values of arrayB
 */
var subtract = function (arrayA, arrayB) {
    return arrayA.filter(function (n) { return !arrayB.includes(n); });
};
exports.subtract = subtract;
/**
 * Checks of setA is equal of setB assuming the sets are of same type
 * @param setA
 * @param setB
 * @returns a boolean
 */
var areSetsEqual = function (setA, setB) {
    var e_1, _a;
    if (setA.size !== setB.size)
        return false;
    try {
        for (var setA_1 = __values(setA), setA_1_1 = setA_1.next(); !setA_1_1.done; setA_1_1 = setA_1.next()) {
            var a = setA_1_1.value;
            if (!setB.has(a))
                return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (setA_1_1 && !setA_1_1.done && (_a = setA_1.return)) _a.call(setA_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
exports.areSetsEqual = areSetsEqual;
/**
 * Accepts a string and a string array and returns the duplicate based on the original name
 * @param originalName
 * @param existingNames
 * @returns duplicate name and number or occurences
 */
var duplicateEntityName = function (originalName, existingNames) {
    if (originalName.charAt(originalName.length - 1) === ')') {
        for (var i = originalName.length - 2; i > 1; i--) {
            if (originalName.charAt(i) === '(') {
                originalName = originalName.substring(0, i - 1).trimEnd();
                break;
            }
        }
    }
    var originalNameEscaped = originalName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var copyNumbers = existingNames
        .filter(function (n) { return n.match(new RegExp("(^(".concat(originalNameEscaped, ")( \\(\\d+\\))?$)"), 'g')); })
        .map(function (n) {
        var regex = new RegExp("((\\(\\d+\\)))", 'g');
        var regexResponses = regex.exec(n);
        return (0, guards_1.isUndefinedOrNullOrEmptyArray)(regexResponses) || (regexResponses === null || regexResponses === void 0 ? void 0 : regexResponses.length) === 0
            ? 0
            : +regexResponses[(regexResponses === null || regexResponses === void 0 ? void 0 : regexResponses.length) - 1].substring(1, regexResponses[(regexResponses === null || regexResponses === void 0 ? void 0 : regexResponses.length) - 1].length - 1);
    });
    var maxCopyNumber = Math.max.apply(null, copyNumbers);
    return originalName + " (".concat(maxCopyNumber + 1, ")");
};
exports.duplicateEntityName = duplicateEntityName;
/**
 * Takes a hex color string and factor and darkens or lights the color based on the value of the factor
 * @example lightenDarkenColor('#FF0000', -50) => '#cd0000'
 * @param color
 * @param factor
 * @returns lightend or darkened color
 */
var lightenDarkenColor = function (color, factor) {
    var usePound = false;
    if (color[0] == '#') {
        color = color.slice(1);
        usePound = true;
    }
    var num = parseInt(color, 16);
    var red = (num >> 16) + factor;
    if (red > 255)
        red = 255;
    else if (red < 0)
        red = 0;
    var green = (num & 0x0000ff) + factor;
    if (green > 255)
        green = 255;
    else if (green < 0)
        green = 0;
    var blue = ((num >> 8) & 0x00ff) + factor;
    if (blue > 255)
        blue = 255;
    else if (blue < 0)
        blue = 0;
    return (usePound ? '#' : '') + String('000000' + (green | (blue << 8) | (red << 16)).toString(16)).slice(-6);
};
exports.lightenDarkenColor = lightenDarkenColor;
/**
 * Checks if the passed string is a valid email
 * @param email
 * @returns true or false
 */
var validateEmailRegex = function (email) {
    return (email
        .toLocaleLowerCase()
        .match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null);
};
exports.validateEmailRegex = validateEmailRegex;
/**
 * Check if the given email belongs to a GWI employee
 * @param email
 * @returns true or false
 */
var checkIfIsInternalEmail = function (email) {
    if ((0, guards_1.isUndefinedOrNull)(email))
        return false;
    if (!(0, exports.validateEmailRegex)(email))
        return false;
    var domain = email
        .split('@')[1]
        .split('.')[0]
        .toLowerCase();
    return domain === 'gwi' || domain === 'globalwebindex';
};
exports.checkIfIsInternalEmail = checkIfIsInternalEmail;
/**
 * Takes a string and: substrings it at max len parameter then removes last 3 and adds 3 dots
 * @example truncateText('Lorem ipsum', 5) => 'Lo...'
 * @param input
 * @param maxLen
 * @returns
 */
var truncateText = function (input, maxLen) {
    if (input.length >= maxLen && !(0, guards_1.isUndefinedOrNullOrEmptyString)(input)) {
        return "".concat(input.substring(0, maxLen - 3), "...");
    }
    return input;
};
exports.truncateText = truncateText;
/**
 * Checks if the subset parameter is superset of first parameter
 * @param superset
 * @param subset
 * @returns
 */
var isSubset = function (superset, subset) { return superset.every(function (val) { return subset.includes(val); }); };
exports.isSubset = isSubset;
var numberWithCommas = function (x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
exports.numberWithCommas = numberWithCommas;
/**
 * Adds a value to an array only if the value is unique
 * @param array
 * @param item
 * @returns a new array with the added value or not
 */
var addUnique = function (array, item) {
    var _set = new Set(array);
    _set.add(item);
    return Array.from(_set);
};
exports.addUnique = addUnique;
/**
 * Checks if passed objects are equal using 'fast-deep-equal' package
 * @url https://github.com/epoberezkin/fast-deep-equal for bechmarks and usage
 * @param itemA of type any
 * @param itemB of same type of itemA
 * @returns true false based on equality
 */
var checkDeepEquality = function (itemA, itemB) {
    return (0, fast_deep_equal_1.default)(itemA, itemB);
};
exports.checkDeepEquality = checkDeepEquality;
/**
 * Accepts a GWI package version and returns the short sha (first 7 digits)
 * @param version
 * @returns short sha string
 */
var extractShortSha = function (version) {
    if ((0, guards_1.isUndefinedOrNullOrEmptyString)(version))
        return undefined;
    if (version.includes('git+ssh')) {
        var shortSha = version.split('#')[1].substring(0, 7);
        return shortSha;
    }
    return version;
};
exports.extractShortSha = extractShortSha;
var getPath = function (mfeUrl, featureBranchPrefix) {
    return featureBranchPrefix ? "/".concat(featureBranchPrefix).concat(mfeUrl) : mfeUrl;
};
exports.getPath = getPath;
